// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
export const environment = {
  production: false,
  apiUrl: 'https://cmvc.soportedlr.com.ar',
  // apiUrlComprobante: 'https://jefuitqwfg.execute-api.us-west-2.amazonaws.com/prod/pagos',
  apiUrlComprobante: 'https://cf03f9421j.execute-api.us-west-2.amazonaws.com/prod/pagos',
  apiKeyPagoFacil: '29eac3d9-728a-448b-8d06-2e24d94e91b8',
  endpointPagoFacil: "https://pagosenlinea.pagofacil.com.ar/api/pagosimplificado"
};
*/
export const environment = {
  production: false, // UAT es ambiente de pruebas
  apiUrl: 'https://cmvc.soportedlr.com.ar',
  apiUrlComprobante: 'https://cf03f9421j.execute-api.us-west-2.amazonaws.com/prod/pagos',
  //apiKeyPagoFacil: 'e7ceed9d-0da4-4ed7-a2b2-41a05e1b89d7',
  //clientSecretPagoFacil: 'Nzp8Q~UrFohDg46G2xaBLvU1lIBc4HbgXj3r4b~N',
  //scopePagoFacil: 'api://staging-bind.epays.services/.default',
  //endpointAuthPagoFacil: 'https://login.microsoftonline.com/61ef5b89-8df3-499d-8c13-38fed5d09c72/oauth2/v2.0/token',
  endpointPagoFacil: 'https://9mi3p32oe7.execute-api.us-west-2.amazonaws.com/Dev/pago'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
